
type ErrorSeverity = 'low' | 'medium' | 'high' | 'critical';

export const customClientErrorHandler =  (
    error: any = null,
    severity?: ErrorSeverity | null | undefined,
    title: String | null = "From customErrorHandler",
    meta: any = null,
) => {

    let config;
    let appDebug;

    if(import.meta.client){
        config = useNuxtApp().$config;
        appDebug = useNuxtApp().$config.public.appDebug;
    }

    if(!severity){
        severity = 'low';
    }

    // Log explicitly if request is cancelled by the browser due to race condition
    if (error?.name === 'AbortError') {
        title = 'Fetch request cancelled by the browser';
    }

    let errorOptions = {
        error: error,
        severity: severity,
        title: title,
        meta: meta,
        environment: config?.public.appEnvironment
    }


    if(import.meta.client)
    {
        if(appDebug){
            consoleLog(title, errorOptions, severity);
        }

        if(!config?.public?.ddClientToken){
            return false;
        }

        const datadogLogs = useNuxtApp().$ddLogs;

        if(datadogLogs){
            datadogLogs.logger.error(title, errorOptions, error)
        }

        const datadogRum = useNuxtApp().$ddRum;

        if(datadogRum){
            datadogRum.addError(error, errorOptions);
        }



    }

}
export const customClientWarningHandler =  (
    severity?: ErrorSeverity | null | undefined,
    title: String | null = "From customErrorHandler",
    meta: any = null,
) => {

    let config;
    let appDebug;

    if(import.meta.client){
        config = useNuxtApp().$config;
        appDebug = useNuxtApp().$config.public.appDebug;
    }

    if(!severity){
        severity = 'low';
    }

    let warningOptions = {
        severity: severity,
        title: title,
        meta: meta,
        environment: config?.public.appEnvironment
    }


    if(import.meta.client)
    {
        if(appDebug){
            consoleLog(title, warningOptions, severity);
        }

        if(!config?.public?.ddClientToken){
            return false;
        }

        const datadogLogs = useNuxtApp().$ddLogs;

        if(datadogLogs){
            datadogLogs.logger.warn(title, warningOptions)
        }
    }
}


export const customClientErrorHandlerAsync =  async (
    error: any = null,
    severity?: ErrorSeverity | null | undefined,
    title: String | null = "From customErrorHandler",
    meta: any = null,
) => {
    customClientErrorHandler(error, severity, title, meta);
}
export const customServerErrorHandler =  (
    error: any = null,
    severity: ErrorSeverity | null | undefined = 'low',
    title: String | null = "From customServerErrorHandler",
    meta: any = null,
) => {


    let errorOptions = {
        error: error,
        severity: severity,
        title: title,
        meta: meta,
    }

    consoleLog(title, errorOptions, severity);

}


export const consoleLog =  (title, errorOptions, severity) => {
    if(severity === 'critical' || severity === 'high'){
        console.error(title, errorOptions);
    } else{
        console.log(title, errorOptions);
    }
}
